import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import SearchBarItem from '../SearchBarItem';
import Responsive from 'Components/Responsive';

class Wrapper extends PureComponent {
    render() {
        const { wrapperRef, children, container } = this.props;

        return (
            <div ref={wrapperRef} className="kbe-search-bar-item kbe-header-occupancy-selector-wrapper">
                <Responsive container={container}>
                    { ({ windowWidth }) => (
                        <SearchBarItem
                            removeGlobalClassName
                            label={<FormattedMessage id="bf.occupancy" defaultMessage="bf.occupancy" />}
                        >
                            <div className="kbe-header-occupancy-selector search-bar-input-wrapper-custom-class">
                                <div className={`kbe-dropdown kbe-dropdown-center ${windowWidth < 639 ? 'kbe-dropdown-full-width' : ''}`}>
                                    {children}
                                </div>
                            </div>
                        </SearchBarItem>
                    )}
                </Responsive>
            </div>
        );
    }
}

Wrapper.propTypes = {
    wrapperRef : PropTypes.oneOfType([ PropTypes.func, PropTypes.object ]).isRequired,
    children   : PropTypes.node.isRequired,
    container  : PropTypes.oneOfType([ PropTypes.instanceOf(Element), PropTypes.object ]).isRequired,
};

export default Wrapper;
